module.exports = __webpack_public_path__ + "img/Imagen 3.2ae32b52.png";